import { render, staticRenderFns } from "./DashboardEditNurseDialog.vue?vue&type=template&id=b192f8f6&scoped=true&"
import script from "./DashboardEditNurseDialog.vue?vue&type=script&lang=js&"
export * from "./DashboardEditNurseDialog.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEditNurseDialog.vue?vue&type=style&index=0&id=b192f8f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b192f8f6",
  null
  
)

export default component.exports